import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { defaultNotifier } from 'functions/notificationHandler'
import axiosObj from '../api/config'

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON);
}

export const downloadFile = (url, fileName) => {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch(error => console.error('Download error:', error))
}

export const handleApiResponse = (response, setData, dataKey, options = {}) => {
  const { showErrorNotification = true } = options || {}

  if (response.data.errors) {
    if (showErrorNotification) {
      defaultNotifier(response.data.errors)
    }

    throw response.data.errors;
  }
  setData(response.data?.data[dataKey])
}

export const handleMutation = (response, onSuccess, successMessage) => {
  if (!response) return
  if (response.data.errors) {
    throw response.data.errors;
  }
  onSuccess && onSuccess(response.data)
  successMessage && defaultNotifier(successMessage)
}

export const handleQuery = (query, url, axiosConfig = {}) => {
  const gqlQuery = jsonToGraphQLQuery(query, { pretty: true })

  return axiosObj({
    ...axiosConfig,
    method: 'POST',
    url: url,
    data: {
      variables: {},
      query: gqlQuery
    }
  })
}